query GetAdminFeeSageJournalEntries(
  $page: Int
  $limit: Int
  $search: String
  $statuses: [AdminFeeSageJournalEntryStatus!]
  $journalEntryTypes: [AdminFeeSageJournalEntryGrouping!]
) {
  adminFeeSageJournalEntries(
    page: $page
    limit: $limit
    search: $search
    statuses: $statuses
    journalEntryTypes: $journalEntryTypes
  ) {
    collection {
      id
      glJournalId
      description
      postingDate
      sageId
      lines {
        txnType
        txnAmount {
          minorUnit
          currency
        }
        description
        glAccountId
        locationId
        documentId
        projectId
        salesforceId
        caseRecordId
        caseStageSetToMoneyMovementAt
        caseStageSetToClosedAt
      }
      status
      errorMessage
      createdAt
      updatedAt
      journalEntryType
      sageHref
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
